export default __webpack_public_path__ + "static/media/icon-availability.54aac8da.svg";